export default {"src":"/_next/static/media/heart-pulse-classic-solid.5e3b5334.svg","height":24,"width":24};